import { api } from '@/config/index.js'
import httpApi from '@/utils/http-api.js'

export default {
  getMember: () => {
    return httpApi.getDataViaApi({
      url: api.member.getMember
    })
  },
  createMember: (body) => {
    return httpApi.postDataViaApi({
      url: api.member.createMember,
      body
    })
  },
  markOnboardingCompleted: () => {
    return httpApi.putDataViaApi({
      url: api.member.markOnboardingCompleted
    })
  }
}
